import type { MouseEvent } from "react";
import { ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import ThreeDRotationIcon from "@mui/icons-material/ThreeDRotation";

export type ViewMode = "tree" | "map";

interface ViewToggleProps {
  view: ViewMode;
  onChange: (view: ViewMode) => void;
}

export const ViewToggle = ({ view, onChange }: ViewToggleProps) => {
  const handleChange = (
    _event: MouseEvent<HTMLElement>,
    newView: ViewMode | null,
  ) => {
    if (newView !== null) {
      onChange(newView);
    }
  };

  return (
    <ToggleButtonGroup
      value={view}
      exclusive
      onChange={handleChange}
      size="small"
      sx={{
        backgroundColor: (theme) => theme.palette.background.paper,
      }}
    >
      <ToggleButton
        value="tree"
        sx={{
          padding: (theme) => theme.spacing(0.5, 1.5),
          "&.Mui-selected": {
            backgroundColor: (theme) => theme.palette.primary.main,
            color: (theme) => theme.palette.primary.contrastText,
            "&:hover": {
              backgroundColor: (theme) => theme.palette.primary.dark,
            },
          },
        }}
      >
        <Tooltip title="Tree View">
          <AccountTreeIcon sx={{ fontSize: "1.2rem" }} />
        </Tooltip>
      </ToggleButton>
      <ToggleButton
        value="map"
        sx={{
          padding: (theme) => theme.spacing(0.5, 1.5),
          "&.Mui-selected": {
            backgroundColor: (theme) => theme.palette.primary.main,
            color: (theme) => theme.palette.primary.contrastText,
            "&:hover": {
              backgroundColor: (theme) => theme.palette.primary.dark,
            },
          },
        }}
      >
        <Tooltip title="3D Map View">
          <ThreeDRotationIcon sx={{ fontSize: "1.2rem" }} />
        </Tooltip>
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
